module.exports = __webpack_public_path__ + "static/media/marketplace.735d22c2.png";